module.exports = __webpack_public_path__ + "media/images/christmas_logo_no_writing-88316090299259127905b251c9358eed.png";